import {useState} from 'react'
import {Box, Stack} from '@mui/material'
import FormWrapper from 'src/components/FormWrapper'
import KOHIntegrationPage from 'src/components/kohIntegration/KOHIntegrationPage'
import Logo from 'src/images/logo.png'
import InstitutionResource from 'src/entities/InstitutionResource'

const Main = () => {
  const [showForm, setShowForm] = useState(false)
  const [institutionData, setInstitutionData] =
    useState<InstitutionResource | null>(null)

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Stack direction="column" spacing={4}>
        <Stack
          sx={{
            height: '100px',
            width: '100%',
            background:
              'linear-gradient(135deg, #2E0017 0%, #4d0026 50%, #800040 100%)',
            boxShadow: '0 8px 32px 0 rgba(77, 0, 38, 0.24)',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            zIndex: 10
          }}
        >
          <img
            src={Logo}
            alt="logo"
            style={{height: '90px', objectFit: 'contain'}}
          />
        </Stack>
        <Stack
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%'
          }}
        >
          {showForm ? (
            <FormWrapper institutionData={institutionData} />
          ) : (
            <KOHIntegrationPage
              onProceed={data => {
                setInstitutionData(data)
                setShowForm(true)
              }}
            />
          )}
        </Stack>
      </Stack>
    </Box>
  )
}

export default Main
